module.exports = __webpack_public_path__ + "media/images/pages/fcr/lab-9-4bfbd2586b87867d26cde0b23c308634.png";